const UrlInfo = require('../../../common/components/urlinfo/url-info');

module.exports = function () {
    function SocialButtonsController() {
        this.$onInit = function() {
            // ---------- for demo, don't forget to delete
            //this.url = 'https://www.woolworths.com.au/Recipes/christmas/jamie-olivers-christmas-recipes?name=jamie-s-baked-peach-apricot-pav-with-pistachios-honey&recipeId=4080';
            //this.media = 'https://www.woolworths.com.au/Content/wowRecipeImages/Large/1512-Jamie-BakedPeachApricotPavWithHoneyPistachios.jpg';
            //this.description = "Jamie's Baked Peach & Apricot Pav With Pistachios & Honey";
            //---------- for demo, don't forget to delete
            const urlInfo = new UrlInfo(this.url);
            const mediaInfo = new UrlInfo(this.media);
            this.encodedUrl = encodeURIComponent(urlInfo.href());
            this.encodedMedia = encodeURIComponent(mediaInfo.href());
            this.encodedDescription = encodeURIComponent(this.description);
        };
    }

    return {
        restrict: 'E',
        scope: {
            url: '=',
            media: '=',
            description: '='
        },
        bindToController: true,
        controllerAs: 'ctrl',
        controller: [SocialButtonsController],
        template: require('./social-buttons-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/socialmedia/social-buttons-directive.js
 **/